export default {
  form: {
    accountUpdate: {
      successMessage: "account is succesvol bijgewerkt"
    }
  }
}